
const loginModal = () => {
  const loginInputsToggler = document.getElementById("loginInputsToggler");
  const loginToWpApp = document.getElementById("loginInputsTogglerLink2");
  const loginInputsTogglerEl = document.getElementById("formLogin");
  const displayToggleLoginForm = document.getElementById('displayToggleLoginForm');
  const loginButtonDesktop = document.querySelector(
    "#mobileLogInRegisterSection #wu-mobile-login-button"
  );
  const loginButtonInModal = document.getElementById('myWuLoginBtn');
  const myWuLoginModelRegisterBtn = document.getElementById('myWuLoginModelRegisterBtn');
  const loginForm = document.getElementById('login-form');
  const lastNameField = loginForm.querySelector('#lastNameInputModal');
  const wuNumberField = loginForm.querySelector('#wuNumberInputModal');
  const emailField = loginForm.querySelector('#emailInputModal');
  const phoneField = loginForm.querySelector('#phoneInputModal');

  const myWuCaptchaError = document.getElementById('myWuCaptchaError');
  const loginModalPopupEl = document.querySelector("#loginModal");

  //Send otp popup elements
  const sendOtpModalPopupEl = document.querySelector("#sendOtpPopup");


  //Verify otp popup elements
  const otpVerifyPopupPopupEl = document.getElementById('otpVerifyPopup');

  const flagSelectParentListOtp = document.getElementsByClassName('b-flag-select');
  const language = flagSelectParentListOtp[0].getAttribute('data-language');
  const country = flagSelectParentListOtp[0].getAttribute('data-country');

  // const myWUheroBanneloginButton = document.getElementById('mywu-hero-banner-login-button');
  // myWUheroBanneloginButton && myWUheroBanneloginButton.setAttribute("href", "javascript:void(0);");

  const loginButtonMobile = document.querySelector(
    "#login-nav-item #wu-mobile-login-button"
  );
  // const setLoginModalAttributes = (el) => {
  //   el.setAttribute("data-wu-modal-trigger", "loginModal");
  //   el.setAttribute("href", "javascript:void(0);");

  // }

  // setLoginModalAttributes(loginButtonDesktop);
  // setLoginModalAttributes(loginButtonMobile);

  const loginModalTrigger = document.querySelectorAll(
    '[data-wu-modal-trigger="loginModal"]'
  );
  const loginModalContentEl = document.querySelector(
    '[data-wu-modal-content="loginModal"]'
  );
  const flagSelectParentList = document.getElementsByClassName('b-flag-select');

  const goToInitialStateLoginPopup = () => {
    //  displayToggleLoginForm.classList.add('d-none');
    //  loginInputsTogglerEl.classList.add("d-none");
    //  loginInputsToggler.classList.remove("d-none");
    // loginToWpApp.classList.remove("d-none");
  }

  const loginInputsTogglerFn = (e) => {
    // loginInputsTogglerEl.classList.toggle("d-none");
    //loginInputsToggler.classList.add("d-none");
    // loginToWpApp.classList.add("d-none");
    // displayToggleLoginForm.classList.remove('d-none');
  }
  const initiateGoogleCaptcha = () => {

  }

  const loginModalTriggerFn = (event) => {
    // event.preventDefault();
    // if (loginInputsTogglerEl.classList.contains('d-none') !== -1) {
    //   goToInitialStateLoginPopup()
    // }

    if (!!loginModalContentEl) {
      loginModalContentEl.classList.add("d-flex");
      loginModalContentEl.classList.remove("d-none");

    }
  }
  const myWuLoginModelRegisterBtnFn = (event) => {
    event.preventDefault();
    const country = flagSelectParentList[0].getAttribute('data-country');
    const language = flagSelectParentList[0].getAttribute('data-language');
    var protocol = window.location.protocol,
      port = window.location.port,
      hostname = window.location.hostname;
    const redirectTo = `${protocol}//${hostname}${port && `:${port}`}/${country.toLowerCase()}/${language.toLowerCase()}/web/user/register?Route=PROFILE&RouteType=REDIRECT&requestFrom=mywu&sln=mywu-head-signup-at`
    window.location.href = redirectTo
  }

  const loginSuccessAction = () => {
    if (getMyWUParameterByName('requestFrom') == "wushop" && getMyWUParameterByName('redirectUrl') != "") {
      redirectoWushop();
    } else {
      const country = flagSelectParentList[0].getAttribute('data-country');
      const language = flagSelectParentList[0].getAttribute('data-language');
      window.location.href = `/${country.toLowerCase()}/${language.toLowerCase()}/mywu/rewards.html`;
    }
  }
  const validateLoginLastName = (inputValue, responseValue) => {
    let loginLnStatus = true;
    let inputString = inputValue.trim();
    if (inputString.toLowerCase() != responseValue.toLowerCase()) {
      loginLnStatus = false;
      console.log('login: ln mismatch...');
    }
    return loginLnStatus;
  }
  const validateCountryCode = (responseString) => {
    let loginCountryStatus = true;
    const country = flagSelectParentList[0].getAttribute('data-country');
    if (responseString && responseString.customer.nationality && responseString.customer.nationality != "") {
      const responseCountry = responseString.customer.nationality;
      if (country.toLowerCase() != responseCountry.toLowerCase()) {
        loginCountryStatus = false;
        console.log('login: cntry mismatch...');
      }
    }
    if (responseString && responseString.countryCodeIso2 && responseString.countryCodeIso2 != "") {
      const responseISOCountry = responseString.countryCodeIso2;
      if (country.toLowerCase() == responseISOCountry.toLowerCase()) {
        loginCountryStatus = true;
        console.log('login: iso cntry match...');
      } else {
        //loginCountryStatus = false;
        console.log('login: iso cntry mismatch...');
      }
    }
    return loginCountryStatus;
  }
  const init = () => {
    const navItemLink = document.querySelector(`.wu-header__logo-container .nav-item__link`);
    let hrefLogo = navItemLink && navItemLink.getAttribute(`href`);
    // if(hrefLogo) {
    //   hrefLogo = hrefLogo.replace(`home.html`,`mywu/home.html`);
    //   navItemLink.setAttribute(`href`,hrefLogo);
    // }

    const loginModalSpinnder = document.getElementById('loginModalSpinnder');
    const myWuLoginBtnError = document.getElementById('myWuLoginBtnError');
    loginModalSpinnder.classList.add('d-none');
    myWuLoginBtnError.classList.add('d-none');
    loginForm && loginForm.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.disabled = true;
      loginModalSpinnder.classList.remove('d-none');
      const InputFieldParentDiv = loginForm.querySelector('.login-input-field-wrapper .wu-tab.wu-tab--active');
      //const fieldType = InputFieldParentDiv.getAttribute('data-type');
      var fieldType = "";
      document.querySelectorAll('input[name="mywu-login"]').forEach((elem) => {
        if (elem.checked) {
          fieldType = elem.value;
          console.log("submit---->", fieldType);
        }
      });
      const inputField = loginForm.querySelector(`#${fieldType}InputModal`);
      const captchaInputValue = document.getElementById("humanKey").value;
      let loginwithOTPCountries = ['FR','DE','US','AT','RO','PL'];
      if (loginwithOTPCountries.includes(country.toUpperCase())) {
        callMyWuLookup().initMyWuLoop(fieldType, lastNameField.value, inputField.value, captchaInputValue, country).then((response) => {
          loginModalSpinnder.classList.add('d-none');
          if (response == null) {
            // Error response ..  or no records scenario...
            myWuLoginBtnError.classList.remove('d-none');
            e.disabled = false;
            }
            if (response && response.customer) {
            console.log('login: ln & ctry check..');
            if (!validateLoginLastName(lastNameField.value,  response.customer.name.last) || !validateCountryCode(response)) {
              console.log('Login:mismatch condition..');
              document.getElementById("humanKey").value = "";
              resetCaptcha();
              // mulitple records scenario...
              myWuLoginBtnError.classList.remove('d-none');
              e.disabled = false;
            } else {
              sessionStorage.setItem('mywuApp', JSON.stringify(response));
              //call generate over here.'
              if (response.customer.umnHash && response.customer.umnHash !== "") {
                loginSuccessAction();                
              } else {
                let responseData = {};
                responseData['lastName'] = response.customer.name.last;
                responseData['myWuNumber'] = response.customer.accountNumber;
                getCustomer("generate", responseData, function (umnResponse) {
                  if (umnResponse && umnResponse.umnHash) {
                    response['myWuNumberHash'] = umnResponse.umnHash;
                    sessionStorage.setItem('mywuApp', JSON.stringify(response));
                    loginSuccessAction();
                  } else {
                    console.log('hash not generated for this user....');
                    loginSuccessAction();
                  }
                });
              }
            }  
          } else {
            document.getElementById("humanKey").value = "";
            resetCaptcha();
            // mulitple records scenario...
            myWuLoginBtnError.classList.remove('d-none');
            e.disabled = false;
          }
        })
      }else{
        sendOptShowPopupAction();
      }      
    })
    
    myWuLoginModelRegisterBtn &&
      myWuLoginModelRegisterBtn.addEventListener("click", myWuLoginModelRegisterBtnFn);
    
    //Login with WU.com profile
    loginToWpApp &&
      loginToWpApp.addEventListener("click", (e) => {
        const country = flagSelectParentList[0].getAttribute('data-country');
        const language = flagSelectParentList[0].getAttribute('data-language');
        var protocol = window.location.protocol,
          port = window.location.port,
          hostname = window.location.hostname;
        const redirectTo = `${protocol}//${hostname}${port && `:${port}`}/${country.toLowerCase()}/${language.toLowerCase()}/web/user/login?Route=MYWUSITE&RouteType=REDIRECT`
        window.location.href = redirectTo
      });
    lastNameField &&
      lastNameField.addEventListener("input", loginFormValidateFn);
    wuNumberField &&
      wuNumberField.addEventListener("input", loginFormValidateFn);
    emailField &&
      emailField.addEventListener("input", loginFormValidateFn);
    phoneField &&
      phoneField.addEventListener("input", loginFormValidateFn);
  }
  init();
  if (getMyWUParameterByName('requestFrom') == "wushop") {
    //Trigger Login Modal when request comes from wushop
      sessionStorage.setItem("loginRequestFrom", "wushop");
      sessionStorage.setItem("loginSuccessRedirectUrl", getMyWUParameterByName('redirectUrl'));
  }
  //Send Otp Functionality
  function sendOptShowPopupAction() {
    sendOtpModalPopupEl.classList.remove("d-none");
    loginModalPopupEl.classList.add("d-none");
  }
  //Send Otp button tigger
  const sendOtpBtnEl = document.getElementById('mywuSendOtp');
  if (sendOtpBtnEl !== null) {
    sendOtpBtnEl.addEventListener("click", sendOtpButtonTrigger);
  }
  function sendOtpButtonTrigger() {
    const loginModalSpinnder = document.getElementById('loginModalSpinnder');
    loginModalSpinnder && loginModalSpinnder.classList.remove('d-none');

    var fieldType = "";
    document.querySelectorAll('input[name="mywu-login"]').forEach((elem) => {
      if (elem.checked) {
        fieldType = elem.value;
        console.log("submit---->", fieldType);
      }
    });
    const inputField = loginForm.querySelector(`#${fieldType}InputModal`);
    let requestPayLoad = {};
    requestPayLoad["countryCode"] = country.toUpperCase();
    requestPayLoad["language"] = language.toLowerCase();
    requestPayLoad["fieldType"] = fieldType;
    requestPayLoad["lastName"] = lastNameField.value;
    requestPayLoad["wuNumber"] = fieldType == 'wuNumber' ? inputField.value : '';
    requestPayLoad["wuEmail"] = fieldType == 'email' ? inputField.value : '';
    requestPayLoad["wuPhoneNo"] = fieldType == 'phone' ? inputField.value : '';
    sendOtp(requestPayLoad);
  }
  function sendOtp(requestPayLoad) {
    const loginModalSpinnder = document.getElementById('loginModalSpinnder');
    const otpVerifyPopupPopupEl = document.getElementById('otpVerifyPopup');
          const sendOtpPopupEl = document.getElementById('sendOtpPopup');
    const otpPhoneHd = document.querySelector('.otp-phone-hd');
    const otpEmailHd = document.querySelector('.otp-email-hd');
    const otpPhonecontact = document.querySelector('.verify-mb');
    const otpEmailcontact = document.querySelector('.verify-em');
    const otpPhoneDesc = document.querySelector('.otp-phone-desc');
    const otpEmailDesc = document.querySelector('.otp-email-desc');
    const otpVerifyEmail = document.querySelector('#otpverify_email');
    const otpVerifyPhone = document.querySelector('#otpverify_phone');
    sendOtpService(requestPayLoad, function (otpResponse) {
      if (otpResponse) {
        // if (otpResponse.data.guestLogin.errorCode !== undefined) {
        if (otpResponse.data.guestLogin.errorCode == 'UCDNDFND11') {
          const myWuSendOtpCustomerError = document.getElementById('customer_details_error');
          myWuSendOtpCustomerError.classList.remove('d-none');
          loginModalSpinnder && loginModalSpinnder.classList.add('d-none');
          return;
        } else if (otpResponse.data.guestLogin.errorCode == 'EA2011') {
          const myWuSendOtpUmnError = document.getElementById('send_otp_error');
          myWuSendOtpUmnError.classList.remove('d-none');
          loginModalSpinnder && loginModalSpinnder.classList.add('d-none');
          return;
        } else if (otpResponse.data.guestLogin.errorCode == 'EA1205') {
          const myWuSendOtpCustomerError = document.getElementById('customer_details_error');
          myWuSendOtpCustomerError.classList.remove('d-none');
          loginModalSpinnder && loginModalSpinnder.classList.add('d-none');
          return;
        } else if (otpResponse.data.guestLogin.errorCode == 'EA1206') {
          const myWuSendOtpMultipleError = document.getElementById('multiple_account_error');
          myWuSendOtpMultipleError.classList.remove('d-none');
          loginModalSpinnder && loginModalSpinnder.classList.add('d-none');
          return;
        } else if (otpResponse.data.guestLogin.errorCode !== undefined) {
          const myWuSendOtpError = document.getElementById('send_otp_generic_error');
          myWuSendOtpError.classList.remove('d-none');
          loginModalSpinnder && loginModalSpinnder.classList.add('d-none');
          return;
        } else {
          if (otpVerifyPopupPopupEl != null) {
            otpVerifyPopupPopupEl.classList.remove("d-none");
            sendOtpPopupEl.classList.add("d-none");
            if ( otpResponse.data.guestLogin.factor.factorType === 'EMAIL') {
              otpEmailDesc.classList.remove("d-none");
              otpEmailHd.classList.remove("d-none");
              otpEmailcontact.classList.remove("d-none");
              otpVerifyEmail.innerText = otpResponse.data.guestLogin.factor.factorValue;
            }
            if (otpResponse.data.guestLogin.factor.factorType  === 'SMS') {
              otpPhoneDesc.classList.remove("d-none");
              otpPhoneHd.classList.remove("d-none");
              otpPhonecontact.classList.remove("d-none");
              otpVerifyPhone.innerText = otpResponse.data.guestLogin.factor.factorValue;
            }

          }
        }

      }
    });

  }

  const resendOtpBtnEl = document.getElementById('resend-otpcode');
  if (resendOtpBtnEl !== null) {
    resendOtpBtnEl.addEventListener("click", resendCodeButtonTrigger);
  }
  function resendCodeButtonTrigger(){
    const loginModalSpinnder = document.getElementById('loginModalSpinnder');
    loginModalSpinnder && loginModalSpinnder.classList.add('d-none');

otpVerifyPopupPopupEl.classList.add("d-none");
              loginModalPopupEl.classList.remove("d-none");
  }
  const verifyOtpBtnEl = document.getElementById('mywuverifyOtp');
  if (verifyOtpBtnEl !== null) {
    verifyOtpBtnEl.addEventListener("click", verifyOtpButtonTrigger);
  }
  function verifyOtpButtonTrigger(event) {
    const loginModalSpinnder = document.getElementById('loginModalSpinnder');
    loginModalSpinnder && loginModalSpinnder.classList.remove('d-none');

    let sendOtp = document.getElementById('OTPresendnumbervalid');
    if(sendOtp.value ==''){
      const myWuSendOtpInvalidError = document.getElementById('code_expired_error_message');
          myWuSendOtpInvalidError.classList.remove('d-none');
      loginModalSpinnder && loginModalSpinnder.classList.add('d-none');
      return;
    }

    var fieldType = "";
    document.querySelectorAll('input[name="mywu-login"]').forEach((elem) => {
      if (elem.checked) {
        fieldType = elem.value;
        console.log("submit---->", fieldType);
      }
    });

    const inputField = loginForm.querySelector(`#${fieldType}InputModal`);
    let requestPayLoad = {};

    requestPayLoad["countryCode"] = country.toUpperCase();
    requestPayLoad["language"] = language.toLowerCase();
    requestPayLoad["fieldType"] = fieldType;
    requestPayLoad["lastName"] = lastNameField.value;
    requestPayLoad["wuNumber"] = fieldType == 'wuNumber' ? inputField.value : '';
    requestPayLoad["wuEmail"] = fieldType == 'email' ? inputField.value : '';
    requestPayLoad["wuPhoneNo"] = fieldType == 'phone' ? inputField.value : '';
    requestPayLoad["otp"] = sendOtp.value;
    verifyOtp(requestPayLoad);

  }

  function verifyOtp(requestPayLoad) {
    const loginModalSpinnder = document.getElementById('loginModalSpinnder');

    const myWuLoginBtnError = document.getElementById('myWuLoginBtnError');

    var fieldType = "";
    document.querySelectorAll('input[name="mywu-login"]').forEach((elem) => {
      if (elem.checked) {
        fieldType = elem.value;
        console.log("submit---->", fieldType);
      }
    });

    const inputField = loginForm.querySelector(`#${fieldType}InputModal`);
    const captchaInputValue = document.getElementById("humanKey").value;
    verifyOtpService(requestPayLoad, function (verifyOtpResponse) {
      if (verifyOtpResponse) {
        if (verifyOtpResponse.data.guestLogin.errorCode == 'EA2003') {
          const myWuSendOtpInvalidError = document.getElementById('incorrect_code_error_message');
          myWuSendOtpInvalidError.classList.remove('d-none');
          loginModalSpinnder && loginModalSpinnder.classList.add('d-none');
          return;
        } else if (verifyOtpResponse.data.guestLogin.errorCode !== undefined) {
          const myWuSendOtpVerifyError = document.getElementById('otpVerificationFailedPopup');
          myWuSendOtpVerifyError.classList.remove('d-none');
          otpVerifyPopupPopupEl.classList.add("d-none");
          loginModalSpinnder && loginModalSpinnder.classList.add('d-none');
          return;
        } else {
          callMyWuLookup().initMyWuLoop(fieldType, lastNameField.value, inputField.value, captchaInputValue, country).then((response) => {

            if (response == null) {
              myWuLoginBtnError.classList.remove('d-none');
             }
            if (response && response.customer) {
              console.log('login: ln & ctry check..');
              const otpVerifyPopupPopupEl = document.getElementById('otpVerifyPopup');
              if (!validateLoginLastName(lastNameField.value, response.customer.name.last) || !validateCountryCode(response)) {
                console.log('Login:mismatch condition..');
                document.getElementById("humanKey").value = "";
                resetCaptcha();
                // mulitple records scenario...
                myWuLoginBtnError.classList.remove('d-none');               
              } else {
                sessionStorage.setItem('mywuApp', JSON.stringify(response));
                //call generate over here.'
                if (response.customer.umnHash && response.customer.umnHash !== "") {
                  loginSuccessAction();
                } else {
                  let responseData = {};
                responseData['lastName'] = response.customer.name.last;
                responseData['myWuNumber'] = response.customer.accountNumber;
                  getCustomer("generate", responseData, function (umnResponse) {
                    if (umnResponse && umnResponse.umnHash) {
                      response['myWuNumberHash'] = umnResponse.umnHash;
                      sessionStorage.setItem('mywuApp', JSON.stringify(response));                     
                      loginSuccessAction();                      
                    } else {
                      loginSuccessAction();                     
                    }
                  });
                }
              }


            } else {
              document.getElementById("humanKey").value = "";
              resetCaptcha();
              myWuLoginBtnError.classList.remove('d-none');

              // mulitple records scenario...
              loginModalSpinnder.classList.add('d-none');
              otpVerifyPopupPopupEl.classList.add("d-none");
              loginModalPopupEl.classList.remove("d-none");
              }
          })
        }

      }
    });
  }
}

function redirectoWushop() {
  if (getMyWUParameterByName('redirectUrl') != "") {
    const getToken = getWuShopToken();
    const spinnerEl = document.getElementById('loginModalSpinnder');
    spinnerEl.classList.remove('d-none');
    if (getToken != null) {
      httpRequest.post(getToken.url, getToken.reqPayload, getToken.headerObj)
        .then((response) => {
          try {

            if (sessionStorage.getItem("loginRequestFrom") == "wushop" && sessionStorage.getItem("loginSuccessRedirectUrl") != "") {
              const redirectURL = sessionStorage.getItem("loginSuccessRedirectUrl");
              console.log("redirectURL===>", redirectURL);
              sessionStorage.removeItem("loginRequestFrom");
              sessionStorage.removeItem("loginSuccessRedirectUrl");
              window.location.href = redirectURL + "?lh=" + response.wushopRedirectToken + "&requetFrom=wu";
            }
            spinnerEl.classList.add('d-none');

          } catch (e) {
            spinnerEl.classList.add('d-none');
            console.log(`Error occurred in Wu Shop API`);
            console.error(e);
          }
        }, () => {
          spinnerEl.classList.add('d-none');
          console.log('error');
        });
    }
  }
}

function getMyWUParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2]);
}

function loginFormValidateFn(event) {
  const loginForm = document.getElementById('login-form');
  const lastNameField = loginForm.querySelector('#lastNameInputModal');
  const loginButtonInModal = document.getElementById('myWuLoginBtn');
  let inputField = "";
  if (event.srcElement && event.srcElement.id && event.srcElement.id == "lastNameInputModal") {
    // TODO : Checkf for validation if any.
  } else {
    const InputFieldParentDiv = loginForm.querySelector('.login-input-field-wrapper .wu-tab.wu-tab--active');
    //const fieldType = InputFieldParentDiv.getAttribute('data-type');
    var fieldType = "";
    document.querySelectorAll('input[name="mywu-login"]').forEach((elem) => {
      if (elem.checked) {
        fieldType = elem.value;
      }
    });
    inputField = loginForm.querySelector(`#${fieldType}InputModal`);
    // console.log("fieldType :" + fieldType);
    // console.log("inputField :" + inputField.value)
  }
  const captchaValue = document.getElementById("humanKey").value;
  if (lastNameField.value != "" && inputField != "" && captchaValue != "") {
    //if (lastNameField.value != "" && inputField != "" ) { //TODO Need to capture Google captcha status to
    loginButtonInModal.disabled = false;
  } else {
    console.log('Pending form fields to be filled.');
  }
  return true;
}

function verifyCaptcha(token) {
  return new Promise(function (resolve, reject) {
    if (grecaptcha.getResponse() !== "") {
      let recaptcha_response = token;
      document.getElementById("humanKey").value = recaptcha_response;
      loginFormValidateFn(recaptcha_response);
    }
  });

}
function resetCaptcha() {
  //TODO : refresh captcha...
  console.log('reset captcha called...');
  grecaptcha.reset();
}

if (location.pathname.indexOf("/mywu/login") !== -1) {
  window.addEventListener("load", loginModal);
}

function enableSection() {
  if (document.querySelector('input[name="mywu-login"]')) {
    document.querySelectorAll('input[name="mywu-login"]').forEach((elem) => {
      elem.addEventListener("change", function (event) {
        var selectedItem = event.target.value;
        let myphonenumber = document.getElementById('myWuPhonepanel');
        let myEmail = document.getElementById('myWuEmailpanel');
        let mynumber = document.getElementById('myWuNumberpanel');
        if (selectedItem == "phone") {
          myphonenumber.classList.remove('d-none');
          myEmail.classList.add('d-none');
          mynumber.classList.add('d-none');
        } else if (selectedItem == "email") {
          myphonenumber.classList.add('d-none');
          myEmail.classList.remove('d-none');
          mynumber.classList.add('d-none');
        } else if (selectedItem == "wuNumber") {
          myphonenumber.classList.add('d-none');
          myEmail.classList.add('d-none');
          mynumber.classList.remove('d-none');
        }
      });
    });
  }
}
enableSection();

const readmore = document.getElementById('desc-more');
const readless = document.getElementById('desc-less');
const contentListView = document.getElementById('list-viewdesc');
if (readmore != null) {
  readmore.addEventListener("click", function (event) {
    readmore.classList.add('d-none');
    readless.classList.remove('d-none');
    contentListView.classList.remove('d-none')
  });
}
if (readless != null) {
  readless.addEventListener("click", function (event) {
    readmore.classList.remove('d-none');
    readless.classList.add('d-none');
    contentListView.classList.add('d-none')
  });
}


var campaignTC = document.querySelector('.wu-nav')
if (location.pathname.indexOf("/fr/fr/mywu/campaign-tc-amazon-10e-fr") !== -1 || location.pathname.indexOf("/fr/fr/mywu/campaign-tc-amazon-15e-fr") !== -1 || location.pathname.indexOf("/au/en/mywu/tc_au_diwali_promo/") !== -1 || location.pathname.indexOf("/au/en/mywu/tc_au_new-year-double-campaign/") !== -1 || location.pathname.indexOf("/au/en/mywu/re_engagement_points_incentivized_campaign/") !== -1 || location.pathname.indexOf("/au/en/mywu/re_engagement_vouchers_incentivized_campaign/") !== -1) {
  campaignTC?.classList?.add('d-none');
} else {
  campaignTC?.classList?.remove('d-none');
}

var termslanguageTC = document.querySelector('.wu-header__language-selector__button')
if (location.pathname.indexOf("/sa/en/mywu/mywu-terms-conditions") !== -1) {
  termslanguageTC?.classList?.add('d-none');
} else {
  termslanguageTC?.classList?.remove('d-none');
}
